/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState, useEffect } from 'react';
import { shopContext } from '../../contexts/aniplus';
import { withRouter } from 'react-router-dom';
import axios from 'axios';
import '../../css/event220916_2.css';
// import { ToastContainer, toast } from "react-toastify"; //토스트(toast)
import moment from 'moment';
import { Modal } from 'react-responsive-modal';
import SeatReserveMy from '../../pages/SeatReserveMy';
import io from 'socket.io-client';
// import { useIsMobile } from '../../hooks/useIsMobile';
import { isMobile } from 'react-device-detect';
let socket;
const Event202502_love = (props) => {
  const { loginId, charImg, history, imgUrl } = props;
  const [listShow, setListShow] = useState(false);
  const [seatShow, setSeatShow] = useState(false);
  // const { isMobile } = useIsMobile();
  const ticketCode = 25;

  // const initSocket = () => {
  //   socket = io('http://son.aniplustv.com:4000');
  // };
  const _seat = () => {
    setSeatShow(true);
  };

  const _ticket = () => {
    if (loginId) {
      const startDate = '2025-02-10 14:00:00';
      const endDate = '2025-02-13 16:00:00';

      if (moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >= startDate) {
        if (moment(new Date()).format('YYYY-MM-DD HH:mm:ss') >= endDate) {
          alert('예매가 종료되었습니다.');
        } else {
          history.push('/seatDragon');
        }
      } else {
        alert('예매가 시작전입니다.');
      }
    } else {
      alert('로그인후 이용할 수 있습니다.');
      history.push('/login');
    }
  };

  const _info = () => {
    if (loginId) {
      setListShow(true);
    } else {
      alert('로그인후 이용해 주세요.');
    }
  };

  const _popupClose = () => {
    setListShow(false);
  };
  useEffect(() => {
    // initSocket();
  }, []);
  return (
    <>
      <div className="event_head">
        <h3>러브 라이브! 니지가사키 스쿨 아이돌 동호회 NEXT SKY 특별 상영회</h3>
        <button type="button" className="btnClose">
          <img src="/img/detail_img/close_1.png" alt="닫기" />
        </button>
      </div>
      <div className="eventCon">
        <div className="event220916_2">
          <div className="btm_bar">
            <ul className="bar">
              <li>
                <a style={{ cursor: 'pointer' }} onClick={_seat}>
                  <img
                    src={imgUrl + '/img/event/event20250222/bar_btn01.png'}
                    alt="극장 좌석표"
                    className="img_web"
                  />
                </a>
                <a style={{ cursor: 'pointer' }} onClick={_seat}>
                  <img
                    src={imgUrl + '/img/event/event20250222/m_bar_btn01.png'}
                    alt="극장 좌석표"
                    className="img_m"
                  />
                </a>
              </li>
              <li>
                <a style={{ cursor: 'pointer' }} onClick={_ticket}>
                  <img
                    src={imgUrl + '/img/event/event20250222/bar_btn02.png'}
                    alt="예매하기"
                    className="img_web"
                  />
                </a>
                <a style={{ cursor: 'pointer' }} onClick={_ticket}>
                  <img
                    src={imgUrl + '/img/event/event20250222/m_bar_btn02.png'}
                    alt="예매하기"
                    className="img_m"
                  />
                </a>
              </li>
              <li>
                <a style={{ cursor: 'pointer' }} onClick={_info}>
                  <img
                    src={imgUrl + '/img/event/event20250222/bar_btn03.png'}
                    alt="나의 예매정보"
                    className="img_web"
                  />
                </a>
                <a style={{ cursor: 'pointer' }} onClick={_info}>
                  <img
                    src={imgUrl + '/img/event/event20250222/m_bar_btn03.png'}
                    alt="나의 예매정보"
                    className="img_m"
                  />
                </a>
              </li>
            </ul>
          </div>

          <section className="section">
            <img
              src={imgUrl + '/img/event/event20250222/event_img1.png'}
              alt=""
              className="img_web"
            />
            <img
              src={imgUrl + '/img/event/event20250222/event_img2.png'}
              alt="주의사항"
              className="img_web"
            />
            <img
              src={imgUrl + '/img/event/event20250222/m_event_img1.png'}
              alt="포스터"
              className="img_m"
            />
            <img
              src={imgUrl + '/img/event/event20250222/m_event_img2.png'}
              alt=""
              className="img_m"
            />
          </section>
        </div>
      </div>
      <Modal
        open={seatShow}
        showCloseIcon={false}
        //closeOnOverlayClick={true}
        //closeOnEsc={true}
        center
        styles={{
          modal: {
            backgroundColor: 'black',
          },
        }}
      >
        <div onClick={() => setSeatShow(false)} style={{ cursor: 'pointer' }}>
          <div
            style={{
              position: 'absolute',
              right: -20,
              top: isMobile ? -36 : 80,
              zIndex: 99999999,
            }}
            onClick={() => setSeatShow(false)}
          >
            <img src={imgUrl + '/img/seat/pop_close.png'} />
          </div>
          <img src={imgUrl + '/img/event/event20250222/sitting_list_1.jpg'} />
        </div>
      </Modal>
      <Modal
        open={listShow}
        showCloseIcon={false}
        closeOnOverlayClick={true}
        closeOnEsc={true}
        center
        styles={{
          modal: {
            backgroundColor: 'black',
          },
        }}
      >
        <SeatReserveMy
          ticketCode={ticketCode}
          charImg=""
          popupClose={_popupClose}
          // socket={socket}
        />
      </Modal>
    </>
  );
};

export default shopContext(withRouter(Event202502_love));
